import {ThunkDispatch} from "@reduxjs/toolkit"
import { useNavigate } from "react-router-dom"
import {useSelector, useDispatch } from "react-redux"
import {currentUserActions} from '../reducers/currentUser'
import { useEffect } from "react";
import CanNotAccess from "../pages/CanNotAccess";
import { getTabId } from "../utils/util";
import useTrackPageView from "../hooks/useTrackPageView";

interface  ProtectedPageType {
    children: any,
}

const ProtectedTalentPage = (props: ProtectedPageType) => {
    const {children} = props as any
    const currentUser = useSelector((state: any) => state.currentUser)
    const { talentInfo, email, superUserInfo, staffInfo } = currentUser

    useTrackPageView({ urlPath: "" });

    useEffect(() => {
        const tabId = getTabId();
        const channel = new BroadcastChannel("auth_channel");

        channel.onmessage = (event) => {
            const { type, sender } = event.data || {};

            if (type === "forceReload" && sender !== tabId) {
                window.location.reload();
            }
        };

        return () => {
            channel.close();
        };
    }, []);
    
    const navigate = useNavigate();
    const dispatch = useDispatch<ThunkDispatch<any, any, any>>()
    useEffect(() => {
        dispatch(currentUserActions.getCurrentUser({navigate, view: 'talent'}))
    }, []);
    if (talentInfo) {
        if (talentInfo.is_company_expired) {
            return <CanNotAccess />
        }
        return children;
    }

    if(!talentInfo && email) {
        const specialUrls = ['/talent/mypage/change-password'];
        const currentUrl = window.location.pathname;
        if(!superUserInfo && !staffInfo && !specialUrls.includes(currentUrl)) {
            navigate("/talent/login")
        } else {
            return <CanNotAccess />
        }
    } 
    return null;
};

export default ProtectedTalentPage